//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format } from 'date-fns';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';

import eventsData from './events.json';

export default {
  name: 'festivities-calendar',
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      faCalendar,
      seasons: [
        {
          id: 'spring',
          months: ['1', '2', '3'],
          right: '0px',
          top: '-80px',
        },
        {
          id: 'summer',
          months: ['4', '5', '6'],
          right: '-34px',
          top: '-62px',
        },
        {
          id: 'autumn',
          months: ['7', '8', '9'],
          right: '-34px',
          top: '-72px',
        },
        {
          id: 'winter',
          months: ['10', '11', '12'],
          right: '-9px',
          top: '-80px',
        },
      ],
    };
  },
  computed: {
    calendarLocale() {
      switch (this.$i18n.locale) {
        case 'ja':
          return 'ja';
        case 'ko':
          return 'ko';
        case 'zh-hant':
        case 'zh-hans':
          return 'zh-hant';
        default:
          return 'en';
      }
    },
    eventsData() {
      return _.sortBy(eventsData, item => new Date(item.day))
        .filter(event => event.title[this.calendarLocale])
        .map(event => ({
          ...event,
          title: event.title[this.calendarLocale],
        }));
    },
    monthEvents() {
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

      return months.map(month => {
        const monthDate = this.newDate(month);

        return {
          id: month,
          numberName: format(monthDate, 'L'),
          shortName: format(monthDate, 'MMM'),
          fullName: format(monthDate, 'MMMM'),
          events: this.eventsData.filter(event => event.month === month),
        };
      });
    },
    currentMonth() {
      return format(new Date(), 'L');
    },
    currentSeason() {
      return this.seasons.find(({ months }) => months.includes(this.currentMonth));
    },
    upComingEvents() {
      const upComingEvents = this.eventsData.filter(event => this.isDateUpComing(new Date(event.day)));
      // added events from the beginning of the year to show them at the end as upcoming
      return [...upComingEvents, ...this.eventsData.slice(0, 4)].slice(0, 4);
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.calendar'),
          link: this.$link('/calendar').fullPath(),
          active: true,
        },
      ];
    },
  },
  methods: {
    newDate(month) {
      return new Date(2000, month - 1, 1);
    },
    isDateUpComing(date) {
      const currentDay = format(new Date(), 'D', { useAdditionalDayOfYearTokens: true });
      const eventDay = format(date, 'D', { useAdditionalDayOfYearTokens: true });
      return +eventDay > +currentDay;
    },
    // getDayOfMonth(event) {
    //   if (event.month) {
    //     return format(new Date(event.month), 'MMM');
    //   }
    //   return format(new Date(event.day), 'd');
    // },
    formatEventMonth(month) {
      return format(this.newDate(month), 'MMM');
    },
  },
};
